

export const content = {
  'Kantoren': {
    title: 'Kantoren',
    content: `Kantoorpanden moeten wettelijk in 2023 minimaal energielabel C hebben. Dit niveau van isolatie betaalt zich in de regel uit in de vorm van lagere energielasten en verdient zichzelf terug. Op bedrijventerreinen met veel kantoorpanden zijn er goede kansen om gebouwen met minimaal label C te verwarmen met warmtepompen in combinatie met bodemwarmte. Dit kan individueel (per kantoorpand) of collectief (meerdere kantoorgebouwen op één systeem). Collectief verwarmen van kantoorpanden is in de meeste gevallen efficiënter dan individueel.

De komende tijd doen we verder onderzoek naar de mogelijkheden voor aardgasvrije kantoren. Maar door nu al te investeren in isolatie en aan de wettelijke verplichtingen te voldoen, heb je ook goede stappen genomen om voorbereid te zijn op een aardgasvrij kantoor. Ga je aan de slag? Win dan van tevoren advies in, bijvoorbeeld bij de energiemanager voor bedrijven.`
  },
  'Industrie': {
    title: 'Bedrijventerrein',
    content: `Voor bedrijventerreinen ontwikkelen we komend jaar de eerste plannen hoe deze van het aardgas zouden kunnen gaan.`
  },
  'HT': {
    title: 'Hoge temperatuur (> 70 °C)',
    content: `In deze gebieden zijn veel oudere woningen te vinden (voor 1940 gebouwd). Het kan veel geld kosten om zo’n woning flink te isoleren en dat is niet altijd rendabel. 
    
We verwachten voor deze gebieden dat de woningen warmwater nodig houden met een afgiftetemperatuur van meer dan 70 graden. Dit kan bijvoorbeeld met een warmtenet op hoge temperatuur, of door een vorm van duurzaam gas (zoals biogas of waterstofgas) te leveren aan de woningen. Bij zo’n temperatuur voldoen de bestaande radiatoren. 
    
Wanneer je in zo’n oude woning aan slag gaat met verduurzamen, win dan eerst goed advies in of het de investering waard is om stevig te isoleren. Toepassen van een individuele warmtepomp is in de meeste gevallen niet aan te raden gezien de hoge investeringen die dit vraagt.`
  },
  'MT': {
    title: 'Middentemperatuur (55 - 70 °C)',
    content: `In deze gebieden zijn de meeste woningen tussen 1940 en 2005 gebouwd.  Er zijn in de meeste gevallen nog veel isolatiemaatregelen te nemen die zichzelf terugverdienen. Soms zijn deze maatregelen goed ‘zelfstandig’ te nemen en soms is het handig om bij een verbouwing de maatregelen mee te nemen. Bijvoorbeeld: als je de zolder gaat verbouwen, ga dan ook aan de slag met verbeteren van dakisolatie.
    
De meeste van deze woningen hebben nu een CV-ketel. We verwachten voor deze gebieden dat de woningen toe kunnen met een lagere warmwatertemperatuur dan nu het geval is. In veel gevallen is het huis nu al warm te krijgen met de CV op 70 graden. Door stap voor stap goede isolatie toe te passen kun je zelfs toe met 55 graden en bespaar je bovendien energie (en geld). Ga je lager dan 55 graden, dan vraagt dit om extra investeringen in:
* Isolatie
* warm tapwater (extra elektrische verwarming om legionella tegen te gaan)
* warmte-afgiftesysteem (andere radiatoren of vloerverwarming)
* ventilatie

Dit soort watertemperaturen zijn goed te behalen met een warmtenet. Over het algemeen zijn individuele warmtepompen nog niet goed geschikt om dit soort woningen te verwarmen. Een hybride warmtepomp (deel op aardgas) kan een goede tussenoplossing zijn.`
  },
  'LT': {
    title: 'Lage temperatuur (< 55 °C)',
    content: `Woningen gebouwd na 2005 zijn over het algemeen al zeer goed geïsoleerd, waardoor veel geld steken in betere isolatie maar weinig extra energie- en geldbesparing oplevert. In principe kunnen deze woningen nu al met een lage watertemperatuur verwarmd worden en zijn ze ook geschikt om bijvoorbeeld met een individuele warmtepomp verwarmd te worden. 
    
Soms zijn er wel extra investeringen nodig om dit mogelijk te maken, zoals aanleg van vloerverwarming en het installeren van extra systemen om te voorzien in warm tapwater. Het is dus goed om advies in te winnen of deze stap zinvol is. Zeker wanneer de woningen al zijn aangesloten op een warmtenet heeft het weinig zin om extra te investeren in het verlagen van de afgiftetemperatuur. Voor individuele woningen die nu nog zijn aangesloten op aardgas is dit het onderzoeken waard, zeker in wijken waarvan de kans groot is dat er in de toekomst geen warmtenet komt; dit zijn in het algemeen de wijken aan de rand van Veenendaal.`
  }
}


export const screenreader = `
<h3>Kantoren</h3>
<p>
Kantoorpanden moeten wettelijk in 2023 
minimaal energielabel C hebben. Dit niveau van isolatie betaalt zich in 
de regel uit in de vorm van lagere energielasten en verdient zichzelf 
terug. Op bedrijventerreinen met veel kantoorpanden zijn er goede kansen 
om gebouwen met minimaal label C te verwarmen met warmtepompen in 
combinatie met bodemwarmte. Dit kan individueel (per kantoorpand) of 
collectief (meerdere kantoorgebouwen op één systeem). Collectief 
verwarmen van kantoorpanden is in de meeste gevallen efficiënter dan 
individueel.
</p>
<p>
De komende tijd doen we verder onderzoek naar de mogelijkheden voor 
aardgasvrije kantoren. Maar door nu al te investeren in isolatie en aan 
de wettelijke verplichtingen te voldoen, heb je ook goede stappen 
genomen om voorbereid te zijn op een aardgasvrij kantoor. Ga je aan de 
slag? Win dan van tevoren advies in, bijvoorbeeld bij de energiemanager 
voor bedrijven.
</p>

<h3>Bedrijventerrein</h3>
<p>
Voor bedrijventerreinen ontwikkelen 
we komend jaar de eerste plannen hoe deze van het aardgas zouden kunnen 
gaan.
</p>

<h3>Hoge temperatuur</h3>
<p>
In deze gebieden zijn veel oudere woningen te 
vinden (voor 1940 gebouwd). Het kan veel geld kosten om zo’n woning 
flink te isoleren en dat is niet altijd rendabel. 
</p>
<p>
We verwachten voor deze gebieden dat de woningen warmwater nodig houden met een 
afgiftetemperatuur van meer dan 70 graden. Dit kan bijvoorbeeld met een 
warmtenet op hoge temperatuur, of door een vorm van duurzaam gas (zoals 
biogas of waterstofgas) te leveren aan de woningen. Bij zo’n temperatuur 
voldoen de bestaande radiatoren. 
</p>
<p>
Wanneer je in zo’n oude woning aan slag 
gaat met verduurzamen, win dan eerst goed advies in of het de 
investering waard is om stevig te isoleren. Toepassen van een 
individuele warmtepomp is in de meeste gevallen niet aan te raden gezien 
de hoge investeringen die dit vraagt.
</p>

<h3>Middentemperatuur</h3>
<p>
In deze gebieden zijn de meeste woningen 
tussen 1940 en 2005 gebouwd.  Er zijn in de meeste gevallen nog veel 
isolatiemaatregelen te nemen die zichzelf terugverdienen. Soms zijn deze 
maatregelen goed ‘zelfstandig’ te nemen en soms is het handig om bij een 
verbouwing de maatregelen mee te nemen. Bijvoorbeeld: als je de zolder 
gaat verbouwen, ga dan ook aan de slag met verbeteren van dakisolatie.
De meeste van deze woningen hebben nu een CV-ketel. We verwachten voor 
deze gebieden dat de woningen toe kunnen met een lagere 
warmwatertemperatuur dan nu het geval is. In veel gevallen is het huis 
nu al warm te krijgen met de CV op 70 graden. Door stap voor stap goede 
isolatie toe te passen kun je zelfs toe met 55 graden en bespaar je 
bovendien energie (en geld). Ga je lager dan 55 graden, dan vraagt dit 
om extra investeringen in:
</p>
<ul>
  <li>Isolatie</li>
  <li>warm tapwater (extra elektrische verwarming om legionella tegen te gaan)</li>
  <li>warmte-afgiftesysteem (andere radiatoren of vloerverwarming)</li>
  <li>ventilatie</li>
</ul>
<p>
Dit soort watertemperaturen zijn goed te behalen met een warmtenet. Over 
het algemeen zijn individuele warmtepompen nog niet goed geschikt om dit 
soort woningen te verwarmen. Een hybride warmtepomp (deel op aardgas) 
kan een goede tussenoplossing zijn.
</p>

<h3>Lage temperatuur</h3>
<p>
Woningen gebouwd na 2005 zijn over het 
algemeen al zeer goed geïsoleerd, waardoor veel geld steken in betere 
isolatie maar weinig extra energie- en geldbesparing oplevert. In 
principe kunnen deze woningen nu al met een lage watertemperatuur 
verwarmd worden en zijn ze ook geschikt om bijvoorbeeld met een 
individuele warmtepomp verwarmd te worden. 
</p>
<p>
Soms zijn er wel extra investeringen nodig om dit mogelijk te maken, zoals aanleg van 
vloerverwarming en het installeren van extra systemen om te voorzien in 
warm tapwater. Het is dus goed om advies in te winnen of deze stap 
zinvol is. Zeker wanneer de woningen al zijn aangesloten op een 
warmtenet heeft het weinig zin om extra te investeren in het verlagen 
van de afgiftetemperatuur. Voor individuele woningen die nu nog zijn 
aangesloten op aardgas is dit het onderzoeken waard, zeker in wijken 
waarvan de kans groot is dat er in de toekomst geen warmtenet komt; dit 
zijn in het algemeen de wijken aan de rand van Veenendaal.
</p>
`